import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { selectActiveModalName } from 'redux/modules/modals';
import { CmsCta } from './CmsCta';
import { CMS_CTA_TYPES } from './constants';

export const mapStateToProps = (state, { ctaType, values }) => {
  const ctaValues = values || {};

  const isCloseModalCta = ctaType === CMS_CTA_TYPES.CLOSE_MODAL;
  if (isCloseModalCta && !ctaValues.modalName) {
    throw new Error('Close modal CTA requires a values.modalName property to associate it to a modal');
  }

  return {
    ctaValues,
    isExpectedModalActive: isCloseModalCta && selectActiveModalName(state) === ctaValues.modalName,
  };
};

export const CmsCtaContainer = decorateWith(connect(mapStateToProps), withName('CmsCta'))(CmsCta);
